var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"view-equipment-details"},[_c('pageheader',{attrs:{"input":_vm.input}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }